export const LOADER = 'LOADER';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const LOGINUSER = 'LOGINUSER';
export const DASHBOARDSTRETCH = 'DASHBOARDSTRETCH';